export const OFLC_ACCEPTE_INVITATION = "OFLC_ACCEPTE_INVITATION";
export const OFLC_ACCEPTE_INVITATION_SUCCESS =
  "OFLC_ACCEPTE_INVITATION_SUCCESS";
export const OFLC_ACCEPTE_INVITATION_FAILED = "OFLC_ACCEPTE_INVITATION_FAILED";

export function accepteInvitation(payload) {
  return {
    type: OFLC_ACCEPTE_INVITATION,
    payload,
  };
}

export function acceptInvitationSuccess(payload) {
  return {
    type: OFLC_ACCEPTE_INVITATION_SUCCESS,
    payload: payload,
  };
}

export function acceptInvitationFail(payload) {
  return {
    type: OFLC_ACCEPTE_INVITATION_FAILED,
    lockedUserMessage:
      "A previous network change is still in process. Please try again later",
    payload: payload,
  };
}
